// extracted by mini-css-extract-plugin
export default {"wrapper":"PlanningEntrySkeleton_wrapper_evF1z"};